module.exports = __webpack_public_path__ + "img/ios.2fe5ebe4.jpg";